export const getImageDimensions = (file) => {
    return new Promise (function (resolved) {
      var i = new Image();
      i.onload = function(){
        resolved({ w: i.width, h: i.height });
      };
      i.src = file;
    });
};

export const recalculateImageDimensions = (width, height, maxWidth, maxHeight) => {
    const ratio = width / height;
    if (width > maxWidth) {
        width = maxWidth;
        height = width / ratio;
    }

    if (height > maxHeight) {
        height = maxHeight;
        width = ratio * height;
    }

    return { width, height };
};

export const calculatePixelRatio = (width, height, maxWidth, maxHeight) => {
    const widthRatio = Math.round(maxWidth / width);
    const heightRatio = Math.round(maxHeight / height);

    return widthRatio > heightRatio ? widthRatio : heightRatio;
};

export const transformToMultiple = (number, multiple) => {
  const remainder = number % multiple;
  if (remainder === 0) {
    return number;
  } else if (remainder < multiple / 2) {
    return number - remainder;
  } else {
    return number + (multiple - remainder);
  }
};

export const prepareLayerName = (name, isCopy = false) => {
  return isCopy ? name.slice(0, 248) + ' (Copy)' : name.slice(0, 255);
};

export const firstLetterUpper = (text) => text.charAt(0).toUpperCase() + text.slice(1);

export const getCursorStyle = (rotation) => `cursor: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' transform='rotate(${rotation})' xmlns='http://www.w3.org/2000/svg'%3E %3Cg clip-path='url(%23clip0_1120_25769)'%3E %3Cg filter='url(%23filter0_d_1120_25769)'%3E %3Cpath d='M1.52536 10.617C1.36555 11.3095 1.98621 11.9302 2.67874 11.7704L5.59972 11.0963L4.2396 9.7362L5.25969 8.71611C7.32541 6.65039 10.6746 6.65039 12.7403 8.71611L13.7604 9.7362L12.4003 11.0963L15.3213 11.7704C16.0138 11.9302 16.6345 11.3095 16.4746 10.617L15.8006 7.69603L14.4405 9.05614L13.4204 8.03605C10.9791 5.59475 7.02093 5.59475 4.57963 8.03605L3.55955 9.05614L2.19944 7.69603L1.52536 10.617Z' fill='%2322232A'/%3E %3Cpath d='M5.71215 11.5835C5.88926 11.5426 6.03023 11.4089 6.08034 11.2341C6.13045 11.0594 6.0818 10.8713 5.95327 10.7428L4.94671 9.7362L5.61324 9.06966C7.4837 7.19921 10.5163 7.19921 12.3868 9.06966L13.0533 9.7362L12.0467 10.7428C11.9182 10.8713 11.8695 11.0594 11.9197 11.2341C11.9698 11.4089 12.1107 11.5426 12.2879 11.5835L15.2088 12.2576C16.2614 12.5005 17.2047 11.5571 16.9618 10.5046L16.2878 7.5836C16.2469 7.40649 16.1131 7.26551 15.9384 7.2154C15.7637 7.16529 15.5755 7.21395 15.447 7.34247L14.4405 8.34903L13.7739 7.6825C11.1374 5.04594 6.86264 5.04594 4.22608 7.6825L3.55955 8.34903L2.55299 7.34247C2.42446 7.21395 2.23631 7.16529 2.06159 7.2154C1.88687 7.26551 1.75311 7.40649 1.71224 7.5836L1.03817 10.5046C0.795268 11.5571 1.7386 12.5005 2.79117 12.2576L5.71215 11.5835Z' stroke='white' stroke-linejoin='round'/%3E %3C/g%3E %3C/g%3E %3Cdefs%3E %3Cfilter id='filter0_d_1120_25769' x='-0.500977' y='5.20508' width='19.002' height='9.5918' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E %3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E %3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E %3CfeOffset dy='1'/%3E %3CfeGaussianBlur stdDeviation='0.5'/%3E %3CfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/%3E %3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1120_25769'/%3E %3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1120_25769' result='shape'/%3E %3C/filter%3E %3CclipPath id='clip0_1120_25769'%3E %3Crect width='18' height='18' fill='white'/%3E %3C/clipPath%3E %3C/defs%3E %3C/svg%3E ") 9 9, auto!important;`;

export const rgbaToHex = (color) => {
  const rgbaArray = Object.values(color);
  return '#' + rgbaArray
  .map((number, index) => index === 3 ? Math.round(number * 255) : number) // Converts alpha to 255 number
  .map(number => number.toString(16)) // Converts numbers to hex
  .map(string => string.length === 1 ? '0' + string : string) // Adds 0 when length of one number is 1
  .join(''); // Puts the array to togehter to a string
};
